// extracted by mini-css-extract-plugin
export default {"chip":"MGChip_chip__pJ5gT","label":"MGChip_label__FxtBM","iconLeft":"MGChip_iconLeft__uOiFs","iconRight":"MGChip_iconRight__zFR1M"};